import React from 'react';
import {Link} from 'react-router-dom';

const PermissionError = React.memo(() => {
  return (
    <div>
      <h2>You don&apos;t have a permission to view this page</h2>
      <Link to={'/home'}>HOME</Link>
    </div>
  );
});

export default PermissionError;
